import type { IconAsset } from '../Icon.types';

export const chevronRight: IconAsset = {
  bold: {
    l: {
      code: (
        <path
          clipRule='evenodd'
          d='M17.3483 12L8.77298 3.42462L6.65166 5.54594L13.1057 12L6.65166 18.454L8.77298 20.5754L17.3483 12Z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
    m: {
      code: (
        <path
          clipRule='evenodd'
          d='M14.591 9.99999L7.53033 2.93933L5.40901 5.06065L10.3484 9.99999L5.40901 14.9393L7.53033 17.0607L14.591 9.99999Z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
    s: {
      code: (
        <path
          clipRule='evenodd'
          d='M11.564 8.00002L6.6782 2.50348L4.43597 4.49657L7.55016 8.00002L4.43597 11.5035L6.6782 13.4966L11.564 8.00002Z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
  },
  regular: {
    l: {
      code: (
        <path
          clipRule='evenodd'
          d='M16.818 12L8.5962 3.7782L7.18199 5.19241L13.9896 12L7.18199 18.8076L8.5962 20.2218L16.818 12Z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
    m: {
      code: (
        <path
          clipRule='evenodd'
          d='M14.0607 10L7.35355 3.29291L5.93934 4.70712L11.2322 10L5.93934 15.2929L7.35355 16.7071L14.0607 10Z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
    s: {
      code: (
        <path
          clipRule='evenodd'
          d='M11.0607 8.00001L6.35355 3.29291L4.93934 4.70712L8.23223 8.00001L4.93934 11.2929L6.35355 12.7071L11.0607 8.00001Z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
  },
};
